"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coerceTooltipWithoutPadding = exports.coerceTooltip = exports.ChartTooltip = void 0;
exports.isChartTooltipProps = isChartTooltipProps;
var _palette = require("@artsy/palette");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["title", "description", "noPadding"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ChartTooltipWrapper = (0, _styledComponents.default)(_palette.Flex).withConfig({
  displayName: "ChartTooltip__ChartTooltipWrapper",
  componentId: "sc-1g8t4p3-0"
})(["text-align:center;align-items:center;flex-direction:column;white-space:nowrap;"]);

/**
 * Returns tooltip component based on the type of tooltip param passed to it
 * @param tooltip either a component or hash containing `title` and `description`
 */
var coerceTooltip = function coerceTooltip(tooltip) {
  return isChartTooltipProps(tooltip) ? /*#__PURE__*/_react.default.createElement(ChartTooltip, tooltip) : tooltip;
};

/**
 * Similart to `coerceTooltip` but without padding
 * @param tooltip
 */
exports.coerceTooltip = coerceTooltip;
var coerceTooltipWithoutPadding = function coerceTooltipWithoutPadding(tooltip) {
  return isChartTooltipProps(tooltip) ? /*#__PURE__*/_react.default.createElement(ChartTooltip, _extends({
    noPadding: true
  }, tooltip)) : tooltip;
};
exports.coerceTooltipWithoutPadding = coerceTooltipWithoutPadding;
// tslint:disable-next-line:completed-docs
function isChartTooltipProps(obj) {
  var result = obj && _typeof(obj) === "object" && obj.hasOwnProperty("title") && obj.hasOwnProperty("description");
  return result;
}

/**
 * ChartTooltip is the default content format for a label on a BarChart.
 * @param props
 */
var ChartTooltip = function ChartTooltip(_ref) {
  var title = _ref.title,
    description = _ref.description,
    noPadding = _ref.noPadding,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(ChartTooltipWrapper, _extends({
    py: noPadding ? 0 : 0.5,
    px: noPadding ? 0 : 1
  }, others), /*#__PURE__*/_react.default.createElement(_palette.Text, {
    variant: "xs"
  }, title), /*#__PURE__*/_react.default.createElement(_palette.Text, {
    color: "black60",
    variant: "xs"
  }, description));
};
exports.ChartTooltip = ChartTooltip;
ChartTooltip.displayName = "ChartTooltip";
//# sourceMappingURL=ChartTooltip.js.map